import "./app.css";
import AppRouter from "./routes/AppRouter";
import { I18nextProvider } from "react-i18next";
import i18n from "./config/i18n";
import { useDispatch, useSelector } from "react-redux";
import Spinner from "./components/Spinner";
import { ToastContainer } from "react-toastify";
import { LoadScript } from "@react-google-maps/api";
import { useEffect } from "react";
import { getAuthTokenCookie } from "./utils/cookieUtils";
import authService from "./services/authService";
import { setUserData } from "./state/reducers/userSlice";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { setBuySellActiveTab, setProfile, setProjectsActiveTab } from "./state/reducers/applicationSlice";
const libraries = ["places", "drawing"];
function App() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const appState = useSelector((state) => state.application);

  const getConsumerDetails = async () => {
    try {
      let response = await authService.getUserInfo();
      if (response.data.status) {
        let responseData = response.data.data;
        let userData = {
          name: `${responseData?.first_name} ${responseData?.last_name}`,
          firstName: responseData?.first_name,
          lastName: responseData?.last_name,
          email: responseData?.email_address,
          // refreshToken: response.data.data.refreshToken,
          isKycDone: responseData?.kyc_verification_status === 2,
          vendorKycStatus: responseData?.vendor_kyc_verification_status === 2,
          vendorKycStatusId: responseData?.vendor_kyc_verification_status,
          consumerKycStatusId: responseData?.kyc_verification_status,
          userId: responseData?.id,
          loggedIn: "Customer",
        };
        if (!response.data.data.kyc_verification_status) {
          navigate("/signup");
        }
        if (Cookies.get("isFreshLogin") === "true") {
          const cookieOptions = {
            domain: process.env.REACT_APP_DOMAIN,
            secure: !!process.env.REACT_APP_SECURE,
            sameSite: process.env.REACT_APP_SAMESITE,
            path: "/",
          };
          Cookies.set("isFreshLogin", false, cookieOptions);
          dispatch(setProfile(true));
          localStorage.setItem("profile", true);
        }
        dispatch(setBuySellActiveTab(0));
        dispatch(setProjectsActiveTab(0));
        dispatch(setUserData(userData));
        localStorage.setItem("userData", JSON.stringify(userData));
      }
    } catch (error) {
      console.log("Consumer details fetch Error", error);
    }
  };
  // useEffect(() => {
  //   if (!getAuthTokenCookie()) {
  //     removeAuthTokenCookie();
  //   }
  // }, []);
  useEffect(() => {
    if (getAuthTokenCookie()) {
      getConsumerDetails();
    }
  }, []);

  return (
    <div className="App">
      <LoadScript loadingElement={<Spinner />} googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY} libraries={libraries} mapIds={[]}>
        <I18nextProvider i18n={i18n}>
          <AppRouter />
        </I18nextProvider>
      </LoadScript>
      {appState.spinner > 0 && <Spinner />}
      <ToastContainer />
    </div>
  );
}

export default App;
